import styled from "styled-components";
import { hexToRgba } from "../../../../../../themes/hex-to-rgba";
import { grayColors } from "../../../../../../themes/architecture/gray-colors";

export const ClientSettingsToggleDefaultBox = styled.div<{ checked: boolean }>`
    line-height: 1;

    label {
        margin: 0;
        height: 16px;

        span {
            background-color: ${({ checked, theme }) => checked ? hexToRgba(theme.colors.brandPrimary, 0.3) : hexToRgba(grayColors.gray133, 0.4)};
            height: 16px;
            
            &::before {
                bottom: -2px;
                left: 0;

                background-color: ${({ checked, theme }) => checked ? theme.colors.brandPrimary : grayColors.gray133};
                width: 20px; 
                height: 20px;
            }
        }
    }
`